import React from 'react';
import moment from 'moment';
import { Theme } from '@mui/material/styles';
import { DateFormats } from 'constants/common';
import { Box, Typography, Stack } from '@mui/material';
import { DealActivityEventPriority, DealActivityStatus } from '@trnsact/trnsact-shared-types';

import { PRIORITY_CONFIG } from './constants';
import { CalendarEventCardProps } from './types';

export const getPriorityColor =
  (priority?: DealActivityEventPriority | null) =>
  (theme: Theme): string =>
    priority ? PRIORITY_CONFIG[priority].color(theme) : theme.palette.divider;

export const CalendarEventCard = ({ event, sx, showMore = false }: CalendarEventCardProps) => {
  const { title, status, allDay, start } = event;

  const isCancelledOrClosed = status === DealActivityStatus.Closed || status === DealActivityStatus.Cancelled;

  const timeLabel = !allDay && start ? moment(start).format(DateFormats.Time12Hour) : 'All Day';

  return (
    <Box
      sx={[
        theme => ({
          display: 'flex',
          overflow: 'hidden',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: theme.spacing(0.5),
          padding: theme.spacing(0, 0.5),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack direction="row" gap="0.2rem" alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
        <Typography noWrap variant="caption" sx={{ color: 'text.secondary', flexShrink: 0 }}>
          {timeLabel}
        </Typography>

        <Typography
          noWrap
          variant="caption"
          sx={{
            minWidth: 0,
            color: 'black',
            textDecoration: isCancelledOrClosed ? 'line-through' : 'none',
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Box>
  );
};
